/**
 * Censo Hogueras
 * Censo-Hogueras
 *
 * OpenAPI spec version: 1.0.0
 * Contact: you@your-company.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { Ejercicio } from '../model/ejercicio';
import { ResponseAsociaciones } from '../model/responseAsociaciones';
import { ResponseAsociados } from '../model/responseAsociados';
import { ResponseEjercicios } from '../model/responseEjercicios';
import { ResponseStatus } from '../model/responseStatus';
import { Status } from '../model/status';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable({providedIn: 'root'})
export class EjerciciosService {

    protected basePath = 'https://virtserver.swaggerhub.com/emjf1/Censo-Hogueras/1.0.0';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Eliminar un ejercicio por su año
     * 
     * @param ejercicio 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public ejerciciosDelete(ejercicio: number, observe?: 'body', reportProgress?: boolean): Observable<ResponseStatus>;
    public ejerciciosDelete(ejercicio: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ResponseStatus>>;
    public ejerciciosDelete(ejercicio: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ResponseStatus>>;
    public ejerciciosDelete(ejercicio: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (ejercicio === null || ejercicio === undefined) {
            throw new Error('Required parameter ejercicio was null or undefined when calling ejerciciosDelete.');
        }

        let headers = this.defaultHeaders;

        // authentication (BearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ResponseStatus>('delete',`${this.basePath}/ejercicios/${encodeURIComponent(String(ejercicio))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Listar todos los ejercicios
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public ejerciciosGet(observe?: 'body', reportProgress?: boolean): Observable<ResponseEjercicios>;
    public ejerciciosGet(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ResponseEjercicios>>;
    public ejerciciosGet(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ResponseEjercicios>>;
    public ejerciciosGet(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (BearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ResponseEjercicios>('get',`${this.basePath}/ejercicios`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Obtener un ejercicio por su año
     * 
     * @param ejercicio 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public ejerciciosGetById(ejercicio: number, observe?: 'body', reportProgress?: boolean): Observable<ResponseEjercicios>;
    public ejerciciosGetById(ejercicio: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ResponseEjercicios>>;
    public ejerciciosGetById(ejercicio: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ResponseEjercicios>>;
    public ejerciciosGetById(ejercicio: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (ejercicio === null || ejercicio === undefined) {
            throw new Error('Required parameter ejercicio was null or undefined when calling ejerciciosGetById.');
        }

        let headers = this.defaultHeaders;

        // authentication (BearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ResponseEjercicios>('get',`${this.basePath}/ejercicios/${encodeURIComponent(String(ejercicio))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Crear un nuevo ejercicio
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public ejerciciosPost(body: Ejercicio, observe?: 'body', reportProgress?: boolean): Observable<ResponseEjercicios>;
    public ejerciciosPost(body: Ejercicio, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ResponseEjercicios>>;
    public ejerciciosPost(body: Ejercicio, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ResponseEjercicios>>;
    public ejerciciosPost(body: Ejercicio, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling ejerciciosPost.');
        }

        let headers = this.defaultHeaders;

        // authentication (BearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<ResponseEjercicios>('post',`${this.basePath}/ejercicios`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Actualizar un ejercicio existente por su año
     * 
     * @param body 
     * @param ejercicio 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public ejerciciosPut(body: Ejercicio, ejercicio: number, observe?: 'body', reportProgress?: boolean): Observable<ResponseEjercicios>;
    public ejerciciosPut(body: Ejercicio, ejercicio: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ResponseEjercicios>>;
    public ejerciciosPut(body: Ejercicio, ejercicio: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ResponseEjercicios>>;
    public ejerciciosPut(body: Ejercicio, ejercicio: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling ejerciciosPut.');
        }

        if (ejercicio === null || ejercicio === undefined) {
            throw new Error('Required parameter ejercicio was null or undefined when calling ejerciciosPut.');
        }

        let headers = this.defaultHeaders;

        // authentication (BearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<ResponseEjercicios>('put',`${this.basePath}/ejercicios/${encodeURIComponent(String(ejercicio))}`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Obtener las asociaciones de un ejercicio
     * 
     * @param ejercicio 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAsociacionesByEjercicio(ejercicio: number, observe?: 'body', reportProgress?: boolean): Observable<ResponseAsociaciones>;
    public getAsociacionesByEjercicio(ejercicio: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ResponseAsociaciones>>;
    public getAsociacionesByEjercicio(ejercicio: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ResponseAsociaciones>>;
    public getAsociacionesByEjercicio(ejercicio: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (ejercicio === null || ejercicio === undefined) {
            throw new Error('Required parameter ejercicio was null or undefined when calling getAsociacionesByEjercicio.');
        }

        let headers = this.defaultHeaders;

        // authentication (BearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ResponseAsociaciones>('get',`${this.basePath}/ejercicios/${encodeURIComponent(String(ejercicio))}/asociaciones`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Obtener los asociados de un ejercicio
     * 
     * @param ejercicio 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAsociadosByEjercicio(ejercicio: number, observe?: 'body', reportProgress?: boolean): Observable<ResponseAsociados>;
    public getAsociadosByEjercicio(ejercicio: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ResponseAsociados>>;
    public getAsociadosByEjercicio(ejercicio: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ResponseAsociados>>;
    public getAsociadosByEjercicio(ejercicio: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (ejercicio === null || ejercicio === undefined) {
            throw new Error('Required parameter ejercicio was null or undefined when calling getAsociadosByEjercicio.');
        }

        let headers = this.defaultHeaders;

        // authentication (BearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ResponseAsociados>('get',`${this.basePath}/ejercicios/${encodeURIComponent(String(ejercicio))}/asociados`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
